module.exports = __webpack_public_path__ + "assets/snapsvg.6a083096.svg";